import React from "react";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import { ReportsPage, REPORTS_SUBTITLE } from "../Reports";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  IconContainer,
  TitleRow,
} from "./styles";

export const ReportsSection: React.FC = () => {
  return (
    <Card className="reports">
      <CardHeader>
        <TitleRow>
          <IconContainer>
            <AssessmentOutlined />
          </IconContainer>
          <CardTitle>Reports</CardTitle>
        </TitleRow>
        {/* Reuse the page's own subtitle so the embedded card and the standalone page never drift.
            The page header is hidden here (showPageHeader={false}), so this is the only subtitle shown. */}
        <CardDescription>{REPORTS_SUBTITLE}</CardDescription>
      </CardHeader>
      <ReportsPage showPageHeader={false} />
    </Card>
  );
};
